'use client';

import React from "react";
import PageLayout from "@/components/layout/HomePageLayout";
import { Separator } from "@/components/ui/separator";
import { RichTextDisplay } from "@/components/ui/rich-text-display";
import { usePolicy } from "@/hooks/usePolicy";

// Helper function to format dates like "December 5, 2025"
function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
}

const Cookies = () => {
  const { policy, loading, error } = usePolicy('cookies');

  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-0">
        <h1 className="text-2xl font-bold mb-4">Cookie Policy</h1>

        <div className="prose max-w-none [overflow-wrap:anywhere]">
          {loading ? (
            <div className="text-center py-12">
              <p className="text-muted-foreground">Loading cookie policy...</p>
            </div>
          ) : error || !policy ? (
            <div className="text-center py-12">
              <p className="text-muted-foreground">
                {error || 'Cookie policy not available at this time.'}
              </p>
            </div>
          ) : (
            <>
              <p className="text-base text-muted-foreground mb-8">
                <strong>World Class Design OÜ</strong>
                <br />
                {policy.version && (
                  <>
                    <strong>Version:</strong> {policy.version}
                    <br />
                  </>
                )}
                <strong>Last Updated:</strong> {formatDate(policy.updated_at) || 'N/A'}
                <br />
                <strong>Effective Date:</strong> {formatDate(policy.effective_date) || formatDate(policy.created_at) || 'N/A'}
              </p>

              <Separator className="my-8" />

              <RichTextDisplay
                content={policy.content}
                className="prose max-w-none [&_p]:text-base [&_p]:leading-7 [&_p]:my-0 [&_p]:mb-4 [&_h2]:leading-tight [&_h2]:mb-4 [&_h2]:mt-8 [&_h3]:leading-tight [&_h3]:mb-3 [&_h3]:mt-6 [&_ul]:my-0 [&_ul]:mb-4 [&_ol]:my-0 [&_ol]:mb-4 [&_li]:text-base [&_li]:leading-7 [&_li]:m-0 [&_li]:pl-1 [&_li>p]:m-0 [&_table]:w-full [&_table]:border-collapse [&_table]:my-4 [&_th]:border [&_th]:border-gray-300 [&_th]:bg-gray-50 [&_th]:px-4 [&_th]:py-2 [&_th]:text-left [&_th]:font-semibold [&_th]:text-sm [&_td]:border [&_td]:border-gray-300 [&_td]:px-4 [&_td]:py-2 [&_td]:text-sm"
                fallbackText="Content not available."
              />
            </>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default Cookies;
